import React from "react";
import { graphql } from "gatsby";
import CancellationPoliciesTemplate from "@components/cancellationPoliciesPage/cancellationPoliciesTemplate";

const IndexPage = ({
  data: {
    prismic: {
        allCancellation_policiess: {
        edges: {
          0: { node: cancellationPoliciesData },
        },
      },
    },
  },
  pageContext,
}) => (
  <CancellationPoliciesTemplate data={cancellationPoliciesData} pageContext={pageContext} />
);

export const query = graphql`
  query allCancellation_policiess($localeCode: String) {
    prismic {
      allCancellation_policiess(lang: $localeCode) {
        edges {
          node {
            cancellation_policies_hero_image
            cancellation_policies_hero_heading
            cancellation_policies_hero_subheading
            flexible_text
            flexible_title
            moderate_text
            moderate_title
            non_refundable_text
            non_refundable_title
            strict_text
            strict_title
          }
        }
      }
    }
  }
`;

export default IndexPage;
